import styled, { keyframes } from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 50px 0;
`;

export const HeaderAppTitle = styled.h1`
  font-size: 36px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const HeaderAppDesc = styled.p`
  font-size: 24px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoadingIndicator = styled.div`
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 3px solid transparent;
  border-radius: 50%;
  border-top-color: white;
  animation: ${spin} 1s linear infinite;
`;

export const DownloadButton = styled.button<{ $isLoading: boolean }>`
display: flex;
align-items: center;
justify-content: center;
width: 300px;
height: 50px;
font-size: 18px;
font-weight: 600;
color: white;
background-color: ${({ $isLoading }) => ($isLoading ? '#ccc' : '#18A957')};
border: none;
border-radius: 2px;
cursor: ${({ $isLoading }) => ($isLoading ? 'not-allowed' : 'pointer')};
margin-top: 28px;
transition: all 0.3s ease;

&:hover {
  background-color: ${({ $isLoading }) => ($isLoading ? '#ccc' : '#148E45')};
  transform: ${({ $isLoading }) => ($isLoading ? 'none' : 'scale(1.05)')};
}

img {
  width: 18px;
  margin-right: 10px;
  vertical-align: middle;
}
`;

export const DropdownContainer = styled.div`
  position: relative;
  width: 240px;
  margin-top: 10px;
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 34px;
  font-size: 14px;
  font-weight: 500;
  color: #E0E0E0;
  background-color: transparent;
  border: 1px solid #525252;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(82, 82, 82, 0.2);
    border-color: #9E9E9E;
  }

  &::after {
    content: '▼';
    margin-left: 8px;
    font-size: 10px;
    color: #9E9E9E;
  }
`;

export const DropdownMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #212121;
  border: 1px solid #525252;
  border-radius: 2px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  margin-top: 4px;
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  z-index: 1000;
  overflow: hidden;
`;

export const DropdownItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: center; 
  padding: 10px 16px;
  font-size: 13px;
  color: #E0E0E0;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(24, 169, 87, 0.15);
    color: #ffffff;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #525252;
  }

  img {
    width: 14px;
    margin-right: 10px;
    vertical-align: middle;
  }
`;

export const ModalOverlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  background-color: #2C2C2C;
  border-radius: 4px;
  padding: 32px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 8px 0;
  line-height: 1.3;
`;

export const ModalDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #B0B0B0;
  margin: 16px 0;
  line-height: 1.6;
`;

export const ModalButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

export const ModalDownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background-color: #18A957;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #148E45;
    transform: scale(1.02);
  }

  img {
    width: 16px;
    margin-right: 10px;
    vertical-align: middle;
  }
`;

export const ModalDependenciesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background-color: #3774c5;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #2771d1;
    transform: scale(1.02);
  }

  img {
    width: 16px;
    margin-right: 10px;
    vertical-align: middle;
  }
`;

export const ModalCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  color: #E0E0E0;
  background-color: transparent;
  border: 1px solid #525252;
  border-radius: 2px;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(82, 82, 82, 0.2);
    border-color: #9E9E9E;
  }
`;
